import React from "react";

function FluidBedDryer() {
  return (
    <>
      <style>{`
      .technical-spec-section {
        margin: 40px 0;
        overflow-x: auto;
      }
      .technical-spec-section h4 {
        font-family: 'Oxygen', sans-serif;
        font-weight: bold;
        font-size: 24px;
        color: #000;
        margin-bottom: 20px;
      }
      .table {
        width: 100%;
        border-collapse: collapse;
        background: white;
      }
      .table-bordered {
        border: 1px solid #ddd;
      }
      .table-bordered td {
        border: 1px solid #ddd;
        padding: 12px 15px;
        font-size: 14px;
      }
      .table tbody tr:nth-child(even) {
        background-color: #f2f2f2;
      }
      .table td:first-child {
        font-weight: 600;
        width: 40%;
      }
    `}</style>

      <main id="primary" className="site-main">
        <div className="space-for-header"></div>

        {/* Breadcrumb Section */}
        <section
          className="tj-page-header section-gap-x"
          data-bg-image="assets/images/bg/pheader-bg.webp"
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="tj-page-header-content text-center">
                  <h1 className="tj-page-title">Fluid Bed Dryer (FBD)</h1>
                  <div className="tj-page-link">
                    <span><i className="fa-solid fa-home"></i></span>
                    <span><a href="/">Home</a></span>
                    <span><i className="fa-solid fa-arrow-right"></i></span>
                    <span><span>Fluid Bed Dryer (FBD)</span></span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className="page-header-overlay"
            data-bg-image="assets/images/shape/pheader-overlay.png"
          ></div>
        </section>

        {/* MAIN CONTENT */}
        <section className="tj-blog-section section-gap slidebar-stickiy-container">
          <div className="container">
            <div className="row row-gap-5">

              {/* LEFT CONTENT */}
              <div className="col-lg-8">
                <div className="post-details-wrapper">

                  {/* MAIN IMAGE CENTERED */}
                  <div
                    className="blog-images wow fadeInUp"
                    data-wow-delay=".1s"
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <div className="col-sm-6">
                      <img
                        src="assets/images/SD_PHRMA_ALL_MIX _JPGS/1.png"
                        alt="Fluid Bed Dryer"
                      />
                    </div>
                  </div>

                  <h2 className="title title-anim">Fluid Bed Dryer (FBD)</h2>

                  <div className="blog-text">
                    <p className="wow fadeInUp" data-wow-delay=".3s">
                      The Fluid Bed Dryer (FBD) is designed for fast and uniform
                      drying of granules and powders using controlled hot air
                      fluidization. It significantly reduces drying time while
                      ensuring even moisture removal.
                    </p>

                    <p className="wow fadeInUp" data-wow-delay=".4s">
                      With efficient air handling, stainless steel construction,
                      explosion protection, and precise temperature controls, the
                      FBD is ideal for pharmaceutical, chemical, and food
                      industries.
                    </p>
                  </div>

                  {/* EXTRA IMAGES */}
                  <div className="images-wrap">
                    <div className="row">

                      <div className="col-sm-6">
                        <div className="image-box wow fadeInUp" data-wow-delay=".5s">
                          <img
                            src="assets/images/SD_PHRMA_ALL_MIX _JPGS/2.png"
                            alt="Image"
                          />
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="image-box wow fadeInUp" data-wow-delay=".5s">
                          <img
                            src="assets/images/SD_PHRMA_ALL_MIX _JPGS/1.png"
                            alt="Image"
                          />
                        </div>
                      </div>

                    </div>
                  </div>

                  {/* TECHNICAL SPECIFICATIONS */}
                  <div className="technical-spec-section">
                    <h4>Technical Specification</h4>

                    {/* TABLE 1: SMALL MODELS */}
                    <h5 style={{ marginTop: "20px" }}>Small Models</h5>
                    <table className="table table-bordered">
                      <tbody>
                        <tr>
                          <td>Model</td>
                          <td>DPM-FBD-5</td>
                          <td>DPM-FBD-30</td>
                          <td>DPM-FBD-60</td>
                        </tr>

                        <tr>
                          <td>Working Capacity</td>
                          <td>2–3 kg</td>
                          <td>10–15 kg</td>
                          <td>25–40 kg</td>
                        </tr>

                        <tr>
                          <td>Volume</td>
                          <td>5 L</td>
                          <td>30 L</td>
                          <td>60 L</td>
                        </tr>

                        <tr>
                          <td>Blower Motor</td>
                          <td>0.5 HP</td>
                          <td>3 HP</td>
                          <td>5 HP</td>
                        </tr>

                        <tr>
                          <td>Heating Load</td>
                          <td>3 kW</td>
                          <td>12 kW</td>
                          <td>18 kW</td>
                        </tr>
                      </tbody>
                    </table>

                    {/* TABLE 2: MEDIUM MODELS */}
                    <h5 style={{ marginTop: "20px" }}>Medium Models</h5>
                    <table className="table table-bordered">
                      <tbody>
                        <tr>
                          <td>Model</td>
                          <td>DPM-FBD-120</td>
                          <td>DPM-FBD-150</td>
                          <td>DPM-FBD-200</td>
                        </tr>

                        <tr>
                          <td>Working Capacity</td>
                          <td>55–90 kg</td>
                          <td>70–120 kg</td>
                          <td>110–180 kg</td>
                        </tr>

                        <tr>
                          <td>Volume</td>
                          <td>120 L</td>
                          <td>150 L</td>
                          <td>200 L</td>
                        </tr>

                        <tr>
                          <td>Blower Motor</td>
                          <td>7.5 HP</td>
                          <td>10 HP</td>
                          <td>12.5 HP</td>
                        </tr>

                        <tr>
                          <td>Heating Load</td>
                          <td>27 kW</td>
                          <td>36 kW</td>
                          <td>48 kW</td>
                        </tr>
                      </tbody>
                    </table>

                    {/* TABLE 3: LARGE MODEL */}
                    <h5 style={{ marginTop: "20px" }}>Large Model</h5>
                    <table className="table table-bordered">
                      <tbody>
                        <tr>
                          <td>Model</td>
                          <td>DPM-FBD-250</td>
                          <td>DPM-FBD-300</td>
                        </tr>

                        <tr>
                          <td>Working Capacity</td>
                          <td>140–225 kg</td>
                          <td>170–270 kg</td>
                        </tr>

                        <tr>
                          <td>Volume</td>
                          <td>250 L</td>
                          <td>300 L</td>
                        </tr>

                        <tr>
                          <td>Blower Motor</td>
                          <td>15 HP</td>
                          <td>20 HP</td>
                        </tr>

                        <tr>
                          <td>Heating Load</td>
                          <td>60 kW</td>
                          <td>72 kW</td>
                        </tr>
                      </tbody>
                    </table>

                  </div>

                </div>
              </div>

              {/* RIGHT SIDEBAR */}
              <div className="col-lg-4 sidebar-container">
                <div className="tj-main-sidebar">

                  <div className="tj-sidebar-widget service-categories">
                    <h4 className="widget-title">Related Products</h4>
                    <ul>

                      <li>
                        <a href="/rmg">
                          Rapid Mixer Granulator (RMG)
                          <span className="icon"><i className="fa-solid fa-arrow-right"></i></span>
                        </a>
                      </li>

                      <li>
                        <a href="/oscillating-granulator">
                          Oscillating Granulator
                          <span className="icon"><i className="fa-solid fa-arrow-right"></i></span>
                        </a>
                      </li>

                      <li>
                        <a href="/roll-compactor">
                          Roll Compactor
                          <span className="icon"><i className="fa-solid fa-arrow-right"></i></span>
                        </a>
                      </li>

                    </ul>
                  </div>

                </div>
              </div>

            </div>
          </div>
        </section>

      </main>
    </>
  );
}

export default FluidBedDryer;
